<template>
  <div>
    <v-container fluid>

      <Overlay :overlay="overlay"/>

      <v-row>
        <v-col cols="12">
          <v-card class="shadow rounded-lg">

            <v-card-title class="pa-0">
              <RolesTab/>
            </v-card-title>

            <v-divider/>

            <TableView :is-loading="isLoading"
                       :regionals.sync="regionals"
                       @delete="deleteRegional($event)"
                       @refresh="getRegionals"
                       @change-status="changeStatus($event)"/>

          </v-card>
        </v-col>
      </v-row>

      <ConfirmDialog ref="confirmDialog"/>

    </v-container>
  </div>
</template>

<script>
import TableView from "@/views/regionals/components/TableView.vue";
import {HTTP} from "@/http-common";
import RolesTab from "@/components/views/RolesTab.vue";

export default {
    components: {RolesTab, TableView},
    data() {
        return {
            overlay: false,
            isLoading: false,
            regionals: [],
            filter: {}
        }
    },

    methods: {
        getRegionals() {
            this.isLoading = true
            HTTP.get('/regionals', {
                params: {
                    filter: this.filter
                }
            }).then((res) => {
                this.isLoading = false
                this.regionals = res.data.data
            }).catch(err => {
                this.isLoading = false
                console.log(err)
            })
        },
        async deleteRegional(event) {
            if (await this.$refs.confirmDialog.open('', '', {
                icon: '',
                agreeText: '',
                color: 'red',
            })) {
                /**
                 * array
                 */
                let index = event[1]
                let id = event[0]

                this.overlay = true
                HTTP.delete('regionals/' + id).then(() => {
                    this.regionals.splice(index, 1)
                    this.overlay = false
                    this.$successMessage = 'Ce régional a été supprimé avec succès.'
                }).catch(err => {
                    this.overlay = false
                    console.log(err)
                })
            }
        },
        async changeStatus(userId) {
            if (await this.$refs.confirmDialog.open('', 'Êtes-vous sûr de vouloir changer le statut de ce régional ?', {
                icon: 'mdi-backup-restore',
                agreeText: 'Changer',
                color: 'orange',
            })) {
                this.overlay = true
                HTTP.post('/regionals/' + userId + '/change-status').then(() => {
                    this.overlay = false
                    this.getRegionals()
                    this.$successMessage = 'Ce régional a été modifié avec succès.'
                }).catch(err => {
                    this.overlay = false
                    console.log(err)
                })
            }
        },
        onPageChange() {
            this.getRegionals();
        },
    },
    created() {
        this.getRegionals()
    },
    watch: {
        view() {
            this.getRegionals();
        },
    },
}
</script>

<style scoped>
.v-tab {
    min-width: 30px;
}
</style>